<template>
    <div>
        <station-error-messages />
        <create-station-message-card
            v-if="
                user.role === 'super_admin' ||
                    (user.user_permissions &&
                        user.user_permissions.station_messages &&
                        user.user_permissions.station_messages.includes(PermissionsConstants.CREATE))
            "
        />
        <station-message-table />
    </div>
</template>

<script>
import StationMessageTable from '../../components/station-message/StationMessageTable'
import CreateStationMessageCard from '@/components/station-message/CreateStationMessageCard'
import StationErrorMessages from '@/components/station-message/StationErrorMessages'
import { mapActions, mapState } from 'vuex'
import { PermissionsConstants } from '@/permissions'

export default {
    name: 'StationMessageView',
    computed: {
        PermissionsConstants() {
            return PermissionsConstants
        },
        ...mapState('auth', ['user']),
    },
    components: {
        'create-station-message-card': CreateStationMessageCard,
        'station-message-table': StationMessageTable,
        'station-error-messages': StationErrorMessages,
    },
    methods: {
        ...mapActions('stationMessage', ['getStationMessageProbes']),
    },
    async mounted() {
        if (
            !this.user ||
            (this.user.role !== 'super_admin' &&
                !this.user.user_permissions.station_messages.includes(PermissionsConstants.VIEW))
        ) {
            return this.$router.push({ name: 'user-list' })
        }

        await this.getStationMessageProbes()
    },
}
</script>

<style scoped></style>
